// hooks/useThirdPartyInit.ts
import { useEffect } from "react";
import { loadReCaptcha } from "react-recaptcha-google";

export const useRecaptcha = (): void => {
	// Initialize ReCaptcha
	useEffect(() => {
		loadReCaptcha();
	}, []);
};
